import styled from "styled-components"

const ActualiteTitle = styled.h3`
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    color: white;
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const ActualiteImage = styled.h3`
  &:hover ~ ${ActualiteTitle} {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    color: white;
  }
`
const ActualiteCategorie = styled.div`
  & > a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};

    &::after {
      border-bottom: 1px solid
        ${(props) => props.theme.c_color_gradients.c_dark};
    }
  }
`
const ActualiteFooter = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const ActualiteResume = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
export {
  ActualiteTitle,
  ActualiteImage,
  ActualiteCategorie,
  ActualiteFooter,
  ActualiteResume,
}
